
const $ = jQuery.noConflict();

'use strict';
const Popups = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
    $domBody: $('body'),
    $domDoc: $(document),
	$domTouchBtn: $('.js-touch-btn'),
    $domTouchPopup: $('.js-get-touch'),
    $domTouchPopupInner: $('.js-get-touch-inner'),
	$domTouchCloseIcon: $('.js-get-touch__close'),
	$domBrochureBtn: $('.js-brochure-btn'),
	$domBrochurePopup: $('.js-reguest-brochure'),
    $domBrochurePopupInner: $('.js-reguest-brochure-inner'),
	$domBrochureCloseIcon: $('.js-reguest-brochure__close'),
	classActive: 'is-active',
	classPreventScroll: 'prevent-scroll',

	/** @description Initialize */
	init: function() {
        this.popupTouchShow();
		this.popupTouchHide();
		this.popupBrochureShow();
        this.popupBrochureHide();
		this.closeMenuOnOutsideContainerClick();
		this.escKey(Popups.closeTouchPopups);
		this.escKey(Popups.closeBrochurePopups);
        
    },
    
    popupTouchShow: function() {
		Popups.$domTouchBtn.on('click', function() {
			Popups.$domBody.addClass(Popups.classPreventScroll);
			Popups.$domTouchPopup.addClass(Popups.classActive);
		});
	},

	popupTouchHide: function() {
		Popups.$domTouchCloseIcon.on('click', function() {
			Popups.$domTouchPopup.removeClass(Popups.classActive);
			Popups.$domBody.removeClass(Popups.classPreventScroll);
		});
    },

	closeTouchPopups: function() {
		Popups.$domTouchPopup.removeClass(Popups.classActive);
		Popups.$domBody.removeClass(Popups.classPreventScroll);
	},

	popupBrochureShow: function() {
		Popups.$domBrochureBtn.on('click', function() {
			Popups.$domBody.addClass(Popups.classPreventScroll);
			Popups.$domBrochurePopup.addClass(Popups.classActive);
		});
	},

	popupBrochureHide: function() {
		Popups.$domBrochureCloseIcon.on('click', function() {
			Popups.$domBrochurePopup.removeClass(Popups.classActive);
			Popups.$domBody.removeClass(Popups.classPreventScroll);
		});
    },

	closeBrochurePopups: function() {
		Popups.$domBrochurePopup.removeClass(Popups.classActive);
		Popups.$domBody.removeClass(Popups.classPreventScroll);
	},

	/* @description close menu if click outside container */
	closeMenuOnOutsideContainerClick: function() {
		Popups.$domBody.on('mouseup', function(e) {
			e.preventDefault();
			if (Popups.$domTouchPopup.hasClass(Popups.classActive) && !Popups.$domTouchPopupInner.is(e.target) && Popups.$domTouchPopupInner.has(e.target).length === 0 && !Popups.$domTouchCloseIcon.is(e.target)) {
				Popups.closeTouchPopups();
			}
		});
		Popups.$domBody.on('mouseup', function(e) {
			e.preventDefault();
			if (Popups.$domBrochurePopup.hasClass(Popups.classActive) && !Popups.$domBrochurePopupInner.is(e.target) && Popups.$domBrochurePopupInner.has(e.target).length === 0 && !Popups.$domBrochureCloseIcon.is(e.target)) {
				Popups.closeBrochurePopups();
			}
		});
    },
    
    escKey: function(callback) {
		Popups.$domDoc.on('keyup', function(e) {
			if (e.keyCode === 27) {
				callback();
			}
		});
	},
};

export default Popups;